module.exports = __webpack_public_path__ + "img/icon-ve_trungthuong.5c58d0e9.svg";